/* eslint-disable @hapi/scope-start */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    retailersQuery: ()=>retailersQuery,
    useRetailersQuery: ()=>useRetailersQuery,
    retailerByIdQuery: ()=>retailerByIdQuery,
    useRetailerByIdQuery: ()=>useRetailerByIdQuery,
    menuQuery: ()=>menuQuery,
    useMenuQuery: ()=>useMenuQuery,
    brandsByRetailerIdQuery: ()=>brandsByRetailerIdQuery,
    useBrandsByRetailerIdQuery: ()=>useBrandsByRetailerIdQuery,
    specialsByRetailerIdQuery: ()=>specialsByRetailerIdQuery,
    useSpecialsByRetailerIdQuery: ()=>useSpecialsByRetailerIdQuery,
    fetchCartDetailsQuery: ()=>fetchCartDetailsQuery,
    useFetchCartDetailsQuery: ()=>useFetchCartDetailsQuery,
    fetchOrdersQuery: ()=>fetchOrdersQuery,
    useFetchOrdersQuery: ()=>useFetchOrdersQuery,
    createCheckoutMutation: ()=>createCheckoutMutation,
    useCreateCheckoutMutation: ()=>useCreateCheckoutMutation,
    addItemToCartMutation: ()=>addItemToCartMutation,
    useAddItemToCartMutation: ()=>useAddItemToCartMutation,
    removeItemToCartMutation: ()=>removeItemToCartMutation,
    useRemoveItemFromCartMutation: ()=>useRemoveItemFromCartMutation,
    updateQuantityCartMutation: ()=>updateQuantityCartMutation,
    useUpdateQuantityCartMutation: ()=>useUpdateQuantityCartMutation,
    getCustomers: ()=>getCustomers,
    useGetCustomers: ()=>useGetCustomers
});
const _reactQuery = require("react-query");
const _ = require("../..");
const _queries = require("./queries");
const _mutations = require("./mutations");
_exportStar(require("./context"), exports);
_exportStar(require("./schema-types"), exports);
function _exportStar(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) Object.defineProperty(to, k, {
            enumerable: true,
            get: function() {
                return from[k];
            }
        });
    });
    return from;
}
const retailersQuery = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'retailersByLocation',
        query: _queries.retailers,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery).then((data)=>{
        let tempData = data;
        if (_.api.getStore()?.apiEnv === 'production' && data && data?.retailersNearLocation && data?.retailersNearLocation?.length) {
            tempData.retailersNearLocation = data.retailersNearLocation.filter((location)=>!location?.retailer?.name?.toLowerCase()?.includes('sandbox'));
        }
        return tempData;
    });
};
const useRetailersQuery = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>retailersQuery(payload, walletId));
};
const retailerByIdQuery = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'retailerById',
        query: _queries.retailerById,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useRetailerByIdQuery = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>retailerByIdQuery(payload, walletId));
};
const menuQuery = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'menuByType',
        query: _queries.menu,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useMenuQuery = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>menuQuery(payload, walletId));
};
const brandsByRetailerIdQuery = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'brandsByRetailerId',
        query: _queries.brandsByRetailerId,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useBrandsByRetailerIdQuery = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>brandsByRetailerIdQuery(payload, walletId));
};
const specialsByRetailerIdQuery = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'specialsByRetailerId',
        query: _queries.specialsByRetailerId,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useSpecialsByRetailerIdQuery = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>specialsByRetailerIdQuery(payload, walletId));
};
const fetchCartDetailsQuery = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'FetchCartDetails',
        query: _queries.fetchCartDetails,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useFetchCartDetailsQuery = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>fetchCartDetailsQuery(payload, walletId));
};
const fetchOrdersQuery = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'FetchOrders',
        query: _queries.fetchOrders,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useFetchOrdersQuery = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>fetchOrdersQuery(payload, walletId));
};
const createCheckoutMutation = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'CreateCheckout',
        query: _mutations.createCheckout,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useCreateCheckoutMutation = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>createCheckoutMutation(payload, walletId));
};
const addItemToCartMutation = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'AddItemToCheckout',
        query: _mutations.addItemToCart,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useAddItemToCartMutation = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>addItemToCartMutation(payload, walletId));
};
const removeItemToCartMutation = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'RemoveItemFromCheckout',
        query: _mutations.removeItemFromCart,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useRemoveItemFromCartMutation = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>removeItemToCartMutation(payload, walletId));
};
const updateQuantityCartMutation = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'UpdateQuantity',
        query: _mutations.updateQuantityCart,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useUpdateQuantityCartMutation = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>updateQuantityCartMutation(payload, walletId));
};
const getCustomers = (variables, walletId)=>{
    const payloadQuery = {
        operation_name: 'customers',
        query: _queries.fetchCustomers,
        variables
    };
    return _.api.post(`native_app/v2/dutchie?member_id=${walletId}`, payloadQuery);
};
const useGetCustomers = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>getCustomers(payload, walletId));
}; // ===================================================================================================
